<template>
  <div class="enclosure">
    <span>附件：</span>
    <span v-if="!urls">无</span>
    <a v-for="item,i in list" :key="i" style="color: rgba(46, 44, 193, 1); margin-left: 20px;cursor: pointer;" :href="item" target="_blank" >{{fileName(item)}}</a>
  </div>
</template>

<script>
import { fileName } from "@/utils";
import "@/assets/less/details-box.less";
export default {
  props: ["urls"],
  data() {
    return {
      fileName,
    };
  },
  computed: {
    list() {
      return this.urls ? this.urls.split(";") : []
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
    .enclosure {
        // width: 1200px;
        margin-top: 14px;
        font-size: 14px;
        color: rgba(16, 16, 16, 1);
        width: 1057px;
        height: 50px;
        display: flex;
        align-items: center;
        background-color: rgba(247, 247, 247, 1);
        padding-left: 18px;
        flex-wrap: wrap;
    }
</style>